import React from "react";

const ShopNow = () => {
  return (
    <button className="bg-[#9F2B68] text-white text-lg font-bodyFont w-[185px] h-[50px] hover:bg-[#9F2B68] duration-300 font-bold">
      Shop Now
    </button>
  );
};

export default ShopNow;
